(function ($) {
    "use strict";
    $(function () {
        $('.js-select-country').on('click', function () {
            $(this).parent().toggleClass('opened');
            $(this).parent().parent().find('.country-selector').slideToggle('fast');
        });


        $('.js-open-country-selector').on('click', function (e) {
            $('.js-country-selector').toggleClass('opened');
        })


        $('.js-close-country-selector').on('click', function (e) {
            $('.js-country-selector').toggleClass('opened');
        })


    });
})(jQuery);